// services/axiosConfig.ts
import axios from "axios";
import { MAIN_API_URL } from "../config/api";

export const apiClient = axios.create({
  baseURL: MAIN_API_URL,
});

// Intercepteur pour ajouter le token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Intercepteur pour gérer les erreurs 401
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('access_token');
      // Optionnel : rediriger vers login
      // window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);